import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33e2da54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view contact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hero header",
  style: {"background-image":"url('https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3870&q=80')"}
}, null, -1))
const _hoisted_3 = { class: "block content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:hello@wildsys.io?subject=Contact+sur+WildSys",
  target: "_blank"
}, "hello@wildsys.io", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Formulaire de contact", -1))
const _hoisted_8 = { class: "columns" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "required"
}, "Votre nom et prénom", -1))
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "company",
  class: "required"
}, "Votre entreprise", -1))
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "required"
}, "Votre adresse e-mail", -1))
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Votre numéro de téléphone", -1))
const _hoisted_17 = { class: "field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "required"
}, "Sujet", -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "required"
}, "Votre message", -1))
const _hoisted_21 = { class: "ui text muted" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "budget" }, "Avez-vous une enveloppe budgetaire ?", -1))
const _hoisted_25 = { class: "field captcha" }
const _hoisted_26 = { class: "columns" }
const _hoisted_27 = { for: "captcha" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "submit" }

import { ref } from 'vue'
import VueClientRecaptcha from 'vue-client-recaptcha'
import { sendEmail } from '@/services/brevo'

interface FormDef {
    name: string|null;
    company: string|null;
    email: string|null;
    phone: string|null;
    budget: string|null;
    subject: string|null;
    message: string|null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const form = ref<FormDef>({
    name: null,
    company: null,
    email: null,
    phone: null,
    budget: null,
    subject: null,
    message: null
})

const message = ref<string|null>(null)
const captcha = ref(null)
const captchaOriginal = ref<string|null>(null)

const options = ref([
    {
        label: 'Question générale',
        value: 'Question générale'
    },
    {
        label: 'Partenariat',
        value: 'Partenariat'
    },
    {
        label: 'Support technique',
        value: 'Support technique'
    },
    {
        label: 'Proposition commerciale',
        value: 'Proposition commerciale'
    },
    {
        label: 'Demande de devis',
        value: 'Demande de devis'
    },
    {
        label: 'Réclamation',
        value: 'Réclamation'
    },
    {
        label: 'Suggestion ou feedback',
        value: 'Suggestion ou feedback'
    },
    {
        label: "Demande d'emploi ou de stage",
        value: "Demande d'emploi ou de stage"
    },
    {
        label: 'Médias et relations publiques',
        value: 'Médias et relations publiques'
    },
    {
        label: 'Autre',
        value: 'Autre'
    }
])

const sendContact = function(){
    const fm = form.value
    sendEmail({
        'templateId': 3,
        'to': [
            {
                'email': 'hello@wildsys.io',
                'name': 'WildSys'
            }
        ],
        'params': {
            'contact': {
                'company': fm.company,
                'name': fm.name,
                'email': fm.email,
                'phone': fm.phone,
                'budget': fm.budget,
                'subject': fm.subject,
                'message': fm.message?.replace(/\n/g, '<br />')
            }
        }
    }).then(() => {
        sendEmail({
            'templateId': 4,
            'to': [
                {
                    'email': fm.email,
                    'name': fm.name
                }
            ],
            'params': {
                'contact': {
                    'company': fm.company,
                    'name': fm.name,
                    'email': fm.email,
                    'phone': fm.phone,
                    'budget': fm.budget,
                    'subject': fm.subject,
                    'message': fm.message?.replace(/\n/g, '<br />')
                }
            }
        })
        form.value = {
            name: null,
            company: null,
            email: null,
            phone: null,
            budget: null,
            subject: null,
            message: null
        }
        message.value = 'success'
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, (error: any) => {
        message.value = 'error'
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        console.error(error)
    })
}

const getCaptchaCode = function(val: string){
    captchaOriginal.value = val
}

const isFormValid = function(){
    const fm = form.value
    if (!fm.name || !fm.email || !fm.company || !fm.subject || !fm.message || fm.message?.length < 200) return false
    if (!/^([\w\-+.]+)@([\w\-.]{4,})\.[a-z]{2,}$/.test(fm.email)) return false
    if (captcha.value != captchaOriginal.value) return false
    return true
}

return (_ctx: any,_cache: any) => {
  const _component_DefaultHeader = _resolveComponent("DefaultHeader")!
  const _component_VuiMessage = _resolveComponent("VuiMessage")!
  const _component_VuiInput = _resolveComponent("VuiInput")!
  const _component_VuiSelector = _resolveComponent("VuiSelector")!
  const _component_VuiTextarea = _resolveComponent("VuiTextarea")!
  const _component_VuiButton = _resolveComponent("VuiButton")!
  const _component_DefaultFooter = _resolveComponent("DefaultFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DefaultHeader, { title: "Contacter WildSys" }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (message.value == 'success')
          ? (_openBlock(), _createBlock(_component_VuiMessage, {
              key: 0,
              color: "success"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Votre message a bien été enregistré, vous allez reçevoir un e-mail de confirmation sous peu."),
                _hoisted_4,
                _createTextVNode(" Nous vous recontacterons dans les plus brefs délais. ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (message.value == 'error')
          ? (_openBlock(), _createBlock(_component_VuiMessage, {
              key: 1,
              color: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Nous n'avons pas pu prendre en compte votre message."),
                _hoisted_5,
                _createTextVNode(" Merci de nous contacter directement sur "),
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createElementVNode("form", {
          class: "form",
          onSubmit: _withModifiers(sendContact, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_VuiInput, {
                id: "name",
                type: "text",
                modelValue: form.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                placeholder: "John Doe",
                required: "",
                "data-1p-ignore": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_VuiInput, {
                id: "company",
                type: "text",
                modelValue: form.value.company,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.company) = $event)),
                placeholder: "ACME Inc.",
                required: "",
                "data-1p-ignore": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_VuiInput, {
                id: "email",
                type: "text",
                modelValue: form.value.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.email) = $event)),
                placeholder: "john.doe@acme.com",
                required: "",
                "data-1p-ignore": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_VuiInput, {
                id: "phone",
                type: "phone",
                modelValue: form.value.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.phone) = $event)),
                placeholder: "+33601020304",
                required: "",
                "data-1p-ignore": ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_VuiSelector, {
                id: "subject",
                modelValue: form.value.subject,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.subject) = $event)),
                placeholder: "En quoi pouvons-nous vous aider ?",
                values: options.value,
                required: ""
              }, null, 8, ["modelValue", "values"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_VuiTextarea, {
                id: "message",
                type: "text",
                modelValue: form.value.message,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.message) = $event)),
                placeholder: "Indiquez votre projet, vos objectifs, vos besoins",
                rows: "12",
                "data-1p-ignore": ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_21, [
                _createTextVNode(" Un minimum de 200 caractères est requis. "),
                (form.value.message && form.value.message?.length < 200)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "(" + _toDisplayString(200 - form.value.message.length) + " encore nécessaire)", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_VuiInput, {
                id: "budget",
                type: "text",
                modelValue: form.value.budget,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.budget) = $event)),
                placeholder: "Nous pouvons aussi vous donner un ordre de grandeur si besoin",
                "data-1p-ignore": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, [
                  _createVNode(_unref(VueClientRecaptcha), { onGetCode: getCaptchaCode })
                ]),
                _createVNode(_component_VuiInput, {
                  id: "captcha",
                  modelValue: captcha.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((captcha).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              (captcha.value != captchaOriginal.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Merci d'entrer le code ci-dessus pour nous assurer que vous n'êtes pas un bot."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_VuiButton, {
                success: "",
                disabled: !isFormValid()
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Envoyer ma demande ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ], 32)
      ])
    ]),
    _createVNode(_component_DefaultFooter)
  ], 64))
}
}

})